import { Button, IconButton } from '@mui/material';
import { canPlayVideoUrl, getYoutubePreviewThumbnail, getYoutubeVideoId } from '@strength/domain';
import { MdClose, MdPlayCircle } from '@teamworksdev/icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';

const VIDEO_WIDTH = 64;
const VIDEO_HEIGHT = 40;

interface ExerciseVideoPreviewProps {
  videoUrl: string;
}

export const ExerciseVideoPreview = ({ videoUrl }: ExerciseVideoPreviewProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const isYoutube = !!getYoutubeVideoId(videoUrl);
  const canPlay = canPlayVideoUrl(videoUrl);
  const thumbnailUrl = isYoutube ? getYoutubePreviewThumbnail(videoUrl) : undefined;

  return (
    <>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          if (canPlay) setIsOpen(true);
        }}
        onMouseDown={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
        className="relative flex-shrink-0 p-0 rounded-md overflow-hidden cursor-pointer transition-opacity hover:opacity-80"
        style={{ width: VIDEO_WIDTH, height: VIDEO_HEIGHT }}
      >
        {isYoutube && thumbnailUrl ? (
          <img
            src={thumbnailUrl}
            alt={t('videoThumbnail')}
            className="w-full h-full object-cover"
          />
        ) : (
          <video
            preload="metadata"
            src={videoUrl}
            className="w-full h-full object-cover"
          />
        )}
        <div className="absolute inset-0 flex items-center justify-center bg-black/20">
          <MdPlayCircle size={24} color="white" />
        </div>
      </Button>

      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black/70 flex justify-center items-center"
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(false);
          }}
          onMouseDown={(e) => e.stopPropagation()}
          onPointerDown={(e) => e.stopPropagation()}
        >
          <div
            className="relative"
            onClick={(e) => e.stopPropagation()}
          >
            <ReactPlayer
              url={videoUrl}
              controls={true}
              playing={true}
              width="80vw"
              height="80vh"
              style={{ backgroundColor: 'black' }}
            />
            <IconButton
              className="absolute -top-10 right-0 text-white hover:bg-white/10"
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(false);
              }}
              onMouseDown={(e) => e.stopPropagation()}
            >
              <MdClose size={24} color="white" />
            </IconButton>
          </div>
        </div>
      )}
    </>
  );
};
